class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  /* Custom */
  

  static unorderlist_sizes = document.querySelector('[data-filter-name="TALLA"] .parent-display .facets-wrap .facets-layout-list');
  static unorderlist_sizez_mob = document.querySelector('[data-filter-name="TALLA"] .mobile-facets__submenu .facets-layout-list');
 

  static clearText(){  
    let style_filter_texts = document.querySelectorAll('[data-filter-name="ESTILO"] .facet-checkbox__text'); 

    style_filter_texts.forEach(text => {
      text.textContent = text.textContent.replace(/\([^()]*\)/g, '').trim();
    });

    let color_filter_texts = document.querySelectorAll('[data-filter-name="COLOR"] .facet-checkbox__text');

    color_filter_texts.forEach(text => {
      text.textContent = text.textContent.replace(/\([^()]*\)/g, '').trim();
    });  

    let category_filter_texts = document.querySelectorAll('[data-filter-name="CATEGORIA"] .facet-checkbox__text');

    category_filter_texts.forEach(text => {
      text.textContent = text.textContent.replace(/\([^()]*\)/g, '').trim();
    }); 
  }

  static list_sizes;
  static list_sizes_mob;
  
  static summary_size;
  static summary_size_mob; 

  static sizes_selector_nav;
  static sizes_selector_nav_mob;
    
  static initilizeListSelectors() {

    this.ulist_sizes     = document.querySelectorAll('[data-filter-name="TALLA"] .parent-display .facets-wrap .facets-layout-list'); 
    this.ulist_sizes_mob = document.querySelectorAll('[data-filter-name="TALLA"] .mobile-facets__submenu .mobile-facets__list'); 

    this.list_sizes     = document.querySelectorAll('[data-filter-name="TALLA"] .parent-display .facets-wrap .facets-layout-list .list-menu__item .facet-checkbox__text');
    this.list_sizes_mob = document.querySelectorAll('[data-filter-name="TALLA"] .mobile-facets__submenu .facets-layout-list .list-menu__item .facet-checkbox__text'); 

    this.summary_size     = document.querySelector('[data-filter-name="TALLA"] .facets__summary');
    this.summary_size_mob = document.querySelector('[data-filter-name="TALLA"] .mobile-facets__summary + .mobile-facets__submenu .mobile-facets__close-button');

    this.sizes_selector_nav     = document.querySelector('[data-filter-name="TALLA"] .sizes-selector');
    this.sizes_selector_nav_mob = document.querySelector('[data-filter-name="TALLA"] .mobile-facets__summary + .mobile-facets__submenu .mobile-facets__close-button + .sizes-selector');

    this.wrapper_sizes     = document.querySelector('[data-filter-name="TALLA"] .parent-display .facets-wrap .facets-layout-list');
    this.wrapper_sizes_mob = document.querySelector('[data-filter-name="TALLA"] .mobile-facets__submenu .facets-layout-list');

  }

  static addEventGenderClick(list_sizes, type_screen){
    /* Selector de tallas */       
    const gender_selector_sizes = document.querySelectorAll('.sizes-selector .size-gender');         

    // Asigna el evento de click al menú de género de las tallas: 
    gender_selector_sizes.forEach(gender => {
      gender.addEventListener('click', () => {
        // → Limpia las tallas seleccionadas previamente.
        this.cleanSelectedSizes(gender_selector_sizes); 

        // → Asigna la clase al valor cliqueado
        gender.classList.add('selected');
        
        // → Almacena la selección si no ha cambiado la URL. 
        localStorage.setItem('gender_selected', `${gender.firstElementChild.dataset.genderValue}`);            

        // → Válida si se seleccionó el género de Mujer:
        this.buildSizeHTMLStructure(list_sizes, type_screen);        
      });
    });
  }

  static removeEventGenderClick(list_sizes, type_screen) {
      /* Selector de tallas */       
      const gender_selector_sizes = document.querySelectorAll('.sizes-selector .size-gender');      
      this.clearLocalStorage(gender_selector_sizes);   

      // Asigna el evento de click al menú de género de las tallas: 
      gender_selector_sizes.forEach(gender => {
        gender.removeEventListener('click', this.genderClick);
      });

      
  };

  static setSizes(list_sizes, summary_size, sizes_selector_nav, type_screen = 'desktop'){

    // FacetFiltersForm.unorderlist_sizes = document.querySelector('[data-filter-name="TALLA"] .parent-display .facets-wrap .facets-layout-list');
    // let list_sizes = document.querySelectorAll('[data-filter-name="TALLA"] .parent-display .facets-wrap .facets-layout-list .list-menu__item .facet-checkbox__text');
    // let list_sizes_mob = document.querySelectorAll('[data-filter-name="TALLA"] .mobile-facets__submenu .facets-layout-list .list-menu__item .facet-checkbox__text');
    
    console.log(list_sizes);

    console.log('Lista inicial: ');
    console.log(FacetFiltersForm.unorderlist_sizes);

    if(list_sizes){
      list_sizes.forEach(text => {
        text.textContent = text.textContent.replace(/\([^()]*\)/g, '').trim();
      });
    }
    
    // if(list_sizes_mob){
    //   list_sizes_mob.forEach(text => {
    //     text.textContent = text.textContent.replace(/\([^()]*\)/g, '').trim();
    //   });
    // }

    const url = location.href;

    setTimeout(()=> {

      const prev_url = localStorage.getItem('gender_prev_url');
      console.log('URL', url);
      console.log('PREV URL', prev_url);
      if(url !== prev_url){        
        localStorage.removeItem('gender_selected');
      }

      localStorage.setItem('gender_prev_url', url);
    }, 500);
  
    // const summary_size = document.querySelector('[data-filter-name="TALLA"] .facets__summary');
    // const summary_size_mob = document.querySelector('[data-filter-name="TALLA"] .mobile-facets__summary ');

    // const sizes_selector_nav = document.querySelector('[data-filter-name="TALLA"] .sizes-selector');
    console.log('type_screen: ', type_screen);
    console.log('list_sizes: ', list_sizes);
    console.log('summary_size: ', summary_size); 
    console.log('sizes_selector_nav: ', sizes_selector_nav);


    if(summary_size && url) { 
      if(url.includes('mujer')){
        console.log('La URL incluye Mujer');
        if(!sizes_selector_nav){

          if(type_screen === 'desktop'){
            summary_size.insertAdjacentHTML('afterend', 
            `
              <div class="sizes-selector">
                <div class="size-gender selected">
                  <span class="size-gender__name" id="size-gender__women" aria-label="Mujer" data-gender="0" data-gender-value="women">Mujer</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__men" aria-label="Hombre" data-gender="1" data-gender-value="men">Hombre</span>
                </div>
              </div>
            `);
          } else {
            summary_size.insertAdjacentHTML('afterend', 
          `
            <div class="sizes-selector">
              <div class="size-gender selected">
                <span class="size-gender__name" id="size-gender__women-mobile" aria-label="Mujer" data-gender="0" data-gender-value="women">Mujer</span>
              </div>
              <div class="size-gender">
                <span class="size-gender__name" id="size-gender__men-mobile" aria-label="Hombre" data-gender="1" data-gender-value="men">Hombre</span>
              </div>
            </div>
          `);
          }

          
        }      
        
        this.removeEventGenderClick(list_sizes, type_screen);
        this.addEventGenderClick(list_sizes, type_screen);
 
     
 
        this.buildSizeHTMLStructure(list_sizes, type_screen);     
        console.log('Se construyó mujer... ');   
        
      } else if (url.includes('hombre')){
        if(!sizes_selector_nav){
          console.log('La URL incluye Hombre');
          if(type_screen === 'desktop'){
            summary_size.insertAdjacentHTML('afterend', 
            `
              <div class="sizes-selector">
                <div class="size-gender selected">
                  <span class="size-gender__name" id="size-gender__men" aria-label="Hombre" data-gender="0" data-gender-value="men">Hombre</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__women" aria-label="Mujer" data-gender="1" data-gender-value="women">Mujer</span>
                </div>            
              </div>
            `);
          } else {
            summary_size.insertAdjacentHTML('afterend', 
            `
              <div class="sizes-selector">
                <div class="size-gender selected">
                  <span class="size-gender__name" id="size-gender__men-mobile" aria-label="Hombre" data-gender="0" data-gender-value="men">Hombre</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__women-mobile" aria-label="Mujer" data-gender="1" data-gender-value="women">Mujer</span>
                </div>            
              </div>
            `);
          }
      
        }

          /* Selector de tallas */       
          this.removeEventGenderClick(list_sizes, type_screen);
          this.addEventGenderClick(list_sizes, type_screen);


          this.buildSizeHTMLStructure(list_sizes, type_screen);   

      } else if (url.includes('ninos')){
        console.log('La URL incluye Niños');


          list_sizes.forEach(size => {

            if(type_screen === 'desktop'){
              size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.value;
            } else {
              size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.value;
            }

            if(size.textContent.match(/[jk](\d+)/i)) {
              size.parentNode.parentNode.style.display = 'block'; 
              size.textContent = size.textContent.match(/[jk](\d+)/i)[1];
            }else {
              size.parentNode.parentNode.style.display = 'none'; 
            }
          });

          this.changeSizeStructure(FacetFiltersForm.wrapper_sizes, type_screen);      
          this.changeSizeStructure(FacetFiltersForm.wrapper_sizes_mob, type_screen);   







        /* Selector de tallas */       
        // this.removeEventGenderClick(list_sizes, type_screen);
        // this.addEventGenderClick(list_sizes, type_screen);

        // this.buildSizeHTMLStructure(list_sizes, type_screen);     
        console.log('Se construyó NIÑOS... ');   


      } else {

        console.log('La URL no incluye ningun género');

        if(!sizes_selector_nav){

          if(type_screen === 'desktop') {
            summary_size.insertAdjacentHTML('afterend', 
            `
              <div class="sizes-selector">
                <div class="size-gender selected">
                  <span class="size-gender__name" id="size-gender__women" aria-label="Mujer" data-gender="0"data-gender-value="women">Mujer</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__men" aria-label="Hombre" data-gender="1" data-gender-value="men">Hombre</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__kids" aria-label="Niños" data-gender="2" data-gender-value="kids">Niños</span>
                </div>
              </div>
            `);
          } else {
            summary_size.insertAdjacentHTML('afterend', 
            `
              <div class="sizes-selector">
                <div class="size-gender selected">
                  <span class="size-gender__name" id="size-gender__women-mobile" aria-label="Mujer" data-gender="0" data-gender-value="women">Mujer</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__men-mobile" aria-label="Hombre" data-gender="1" data-gender-value="men">Hombre</span>
                </div>
                <div class="size-gender">
                  <span class="size-gender__name" id="size-gender__kids-mobile" aria-label="Niños" data-gender="2" data-gender-value="kids">Niños</span>
                </div>
              </div>
            `);
          }
         
        }

        /* Selector de tallas */       
        this.removeEventGenderClick(list_sizes, type_screen);
        this.addEventGenderClick(list_sizes, type_screen);

        this.buildSizeHTMLStructure(list_sizes, type_screen);        
      }     
    }
  }


  static clearLocalStorage(gender_selector_sizes) {

    console.log('GENDER IN FUNCTION', gender_selector_sizes);
     // Verifica si se dio clic en algun selector de género. Nota: Hace falta que se resetee si pasa a otra página. 
     
    if(localStorage.getItem('gender_selected') === '' || localStorage.getItem('gender_selected') === 'undefined' || (gender_selector_sizes && gender_selector_sizes.length === 0)){
      localStorage.removeItem('gender_selected');
    }

    if(localStorage.getItem('gender_selected') !== null && localStorage.getItem('gender_selected') !== undefined  && localStorage.getItem('gender_selected') !== 'undefined' && gender_selector_sizes) { 
      gender_selector_sizes.forEach(gender => {        
        if(gender.firstElementChild.dataset.genderValue === localStorage.getItem('gender_selected')){
          gender.classList.add('selected');
        } else if(gender.classList.contains('selected')) {
          gender.classList.remove('selected');
        }
      });
    }
  }

  static buildSizeHTMLStructure(list_sizes, type_screen = 'desktop'){

    console.log('Build SIZE');
    console.log(list_sizes);
    /* Géneros del selector */

    let women = '', 
        men = '', 
        kids = '';

    if(type_screen === 'desktop') {
      women = document.getElementById('size-gender__women');
      men   = document.getElementById('size-gender__men');
      kids  = document.getElementById('size-gender__kids'); 
    } else {
      women = document.getElementById('size-gender__women-mobile');
      men   = document.getElementById('size-gender__men-mobile');
      kids  = document.getElementById('size-gender__kids-mobile'); 
    }
   

    if(women && women.parentNode.classList.contains('selected')) {

      console.log('→ Mujer: ');

      console.log(list_sizes);

      list_sizes.forEach(size => {  
      
        if(type_screen === 'desktop'){
          size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.value;
        } else {
          size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.value;
        }       

        if(size.textContent.match(/[mM](\d+)/)) {
          size.parentNode.parentNode.style.display = 'block'; 
          size.textContent = size.textContent.match(/[mM](\d+)/)[1];
        }else {
          size.parentNode.parentNode.style.display = 'none'; 
        }

      });

      this.removeTitleChildrensSizes(type_screen);

  
    } else if(men && men.parentNode.classList.contains('selected')) {

      list_sizes.forEach(size => {
        
        if(type_screen === 'desktop'){
          size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.value;
        } else {
          size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.value;
        }

        if(size.textContent.match(/[hH](\d+)/)) {
          size.parentNode.parentNode.style.display = 'block'; 
          size.textContent = size.textContent.match(/[hH](\d+)/)[1];
        } else {
          size.parentNode.parentNode.style.display = 'none'; 
        }
      });

      this.removeTitleChildrensSizes(type_screen);

    } else if (kids && kids.parentNode.classList.contains('selected') ) {   

      console.log('Estamos en NIÑOS →→');

      list_sizes.forEach(size => {

        if(type_screen === 'desktop'){
          size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.value;
        } else {
          size.textContent = size.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.value;
        }

        if(size.textContent.match(/[jk](\d+)/i)) {
          size.parentNode.parentNode.style.display = 'block'; 
          size.textContent = size.textContent.match(/[jk](\d+)/i)[1];
        }else {
          size.parentNode.parentNode.style.display = 'none'; 
        }
      });

      this.changeSizeStructure(FacetFiltersForm.wrapper_sizes, type_screen);      
      this.changeSizeStructure(FacetFiltersForm.wrapper_sizes_mob, type_screen);      
    } 
  }

  static removeTitleChildrensSizes(type_screen) {

    let juniors_title = '';
    let kids_title = '';

    if(type_screen === 'desktop') {
      juniors_title = document.querySelector('.facets-layout-list.facets__list--vertical [data-title-value="juniors"]');
      kids_title = document.querySelector('.facets-layout-list.facets__list--vertical [data-title-value="kids"]');
    } else {
      juniors_title = document.querySelector('.mobile-facets__list [data-title-value="juniors"]');
      kids_title = document.querySelector('.mobile-facets__list [data-title-value="kids"]');
    }

    if(juniors_title && kids_title){
      juniors_title.remove();
      kids_title.remove();
    }

  }

  static changeSizeStructure(wrapper_sizes, type_screen = 'desktop') {   

    console.log('Change Size Structure');
    console.log(wrapper_sizes);
    console.log('---------------------');

    let liItems = '';
    if( type_screen === 'desktop') {
       liItems = Array.from(wrapper_sizes.querySelectorAll('.facets__item'));
    } else {
      liItems = Array.from(wrapper_sizes.querySelectorAll('.mobile-facets__item'));
    }

 
    // const liItems = Array.from(wrapper_sizes.querySelectorAll('.list-menu__item'));
    const visibleLiItems = liItems.filter(li => li.style.display === 'block');

    console.log('Visibles');
    console.log(visibleLiItems);

    // // Ordenar los elementos <li> visibles según el valor en facet-checkbox__text
    visibleLiItems.sort((a, b) => {

      console.log('A: ', a);
      console.log(': ', b);
      const textA = parseInt(a.querySelector('.facet-checkbox__text').textContent);
      const textB = parseInt(b.querySelector('.facet-checkbox__text').textContent);
      return textA - textB;
    });

    // Reorganizar los elementos <li> visibles en el <ul>
    visibleLiItems.forEach(li => wrapper_sizes.appendChild(li));
  

    // console.log(visibleLiItems);


    // Insertar un <span> en cada <li> hasta llegar al número 28

    let juniors_title = '';
    let kids_title = '';

    if(type_screen === 'desktop') {
      juniors_title = document.querySelector('.facets-layout-list.facets__list--vertical [data-title-value="juniors"]');
      kids_title = document.querySelector('.facets-layout-list.facets__list--vertical [data-title-value="kids"]');
    } else {
      juniors_title = document.querySelector('.mobile-facets__list [data-title-value="juniors"]');
      kids_title = document.querySelector('.mobile-facets__list [data-title-value="kids"]');
    }


    console.log('Niños');
    console.log(juniors_title);
    console.log(kids_title);

    if(!juniors_title && !kids_title && type_screen ){
      visibleLiItems.forEach(li => {

        console.log(li);
  
        const text = parseInt(li.querySelector('.facet-checkbox__text').textContent);
        console.log('→', text);
        if (text == 21) {

          const div = document.createElement('div');
          div.textContent = 'Niños Pequeños (Edades 1-5)';
          div.setAttribute('class', 'kids-size__title list-menu__item facets__item');
          div.setAttribute('data-title-value', 'kids');
          li.insertAdjacentHTML( 'beforebegin',div.outerHTML);
          return false;
  
        } else if (text == 28) {
          const div = document.createElement('div');
          div.textContent = 'Niños Grandes (Edades 6+)';
          div.setAttribute('class', 'kids-size__title list-menu__item facets__item');
          div.setAttribute('data-title-value', 'juniors');
          li.insertAdjacentHTML( 'afterend',div.outerHTML);
          return false; // Continuar iterando
        } else {
          return true; // Detener la iteración
        }
      });
    } else {

      visibleLiItems.forEach(li => {
  
        const text = parseInt(li.querySelector('.facet-checkbox__text').textContent);

        if (text == 28) {

          li.parentNode.insertBefore(juniors_title, li);
          // const div = document.createElement('div');
          // div.textContent = 'Niños Grandes (Edades 6+)';
          // div.setAttribute('class', 'kids-size__title list-menu__item facets__item');
          // div.setAttribute('id', 'juniors');
          // li.insertAdjacentHTML( 'afterend',div.outerHTML);
          return false; // Continuar iterando
        } else {
          return true; // Detener la iteración
        }
      });


    }

 
  }

  static cleanSelectedSizes(selected_sizes){
     /* Quita las selecciones anteriores */
     selected_sizes.forEach(gender => {
      if (gender.classList.contains('selected')) {
        gender.classList.remove('selected');
      }
    });
  }

  static removeItemsFromFilterByURL(){
    const url = window.location.href;
    console.log(url);
    if(url.includes('jibbitz')){
      const price = document.querySelector('#FacetsWrapperDesktop [data-filter-name="PRECIO"]');

      if(price){
        price.remove();
      }

      this.setJibbitzFilter();
    }
  }

  static setJibbitzFilter(){

    const jibbitz_img = document.querySelectorAll('[data-filter-name="CATEGORIA"] .list-menu__item');
    const jibbitz_tree = document.querySelectorAll('[data-filter-name="CATEGORIA"] .facets__label');

    console.log(jibbitz_img);
    console.log(jibbitz_tree);
   
    console.log(jibbitz_img.length);

    let jibbitz_category_name = '';


    if(jibbitz_img.length >= 0){
      jibbitz_tree.forEach(e => {
          switch(e.querySelector('.facet-checkbox__text').textContent.replace(/ {2}/g, ' ').toUpperCase().trim()){
              case 'JIBBITZ DE ANIMALES':                              
                  // console.log('JIBBITZ DE ANIMALES');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/animals.png?v=1676913090', 'animales');
                  jibbitz_category_name = 'Jibbitz de Animales';
              break;
              
              case 'JIBBITZ DE COMIDA':
                  // console.log('JIBBITZ DE COMIDA');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/food-drink.png?v=1676913090', 'comida');
                  jibbitz_category_name = 'Jibbitz de Comida';
              break;
              
              case 'JIBBITZ DE DEPORTES':
                  // console.log('JIBBITZ DE DEPORTES');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/sports.png?v=1676913090', 'deportes');
                  jibbitz_category_name = 'Jibbitz de Deportes';
              break;
              
              case 'JIBBITZ DE INTERESES Y HOBBIES':
                  // console.log('JIBBITZ DE INTERESES Y HOBBIES');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/hobbies-interests.png?v=1676913090', 'intereses-y-hobbies');
                  jibbitz_category_name = 'Jibbitz de Intereses y Hobbies';
              break;
              
              case 'JIBBITZ DE JOYERÍA':
                  // console.log('JIBBITZ DE JOYERÍA');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jewels-metals.png?v=1676913090', 'joyeria');
                  jibbitz_category_name = 'Jibbitz de Joyería';
              break;
              
              case 'JIBBITZ DE LETRAS Y NÚMEROS':
                  // console.log('JIBBITZ DE LETRAS Y NÚMEROS');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/letters_-_numbers.png?v=1677535740', 'numeros');
                  jibbitz_category_name = 'Jibbitz de Números';
              break;
              
              case 'JIBBITZ DE NATURALEZA':
                  // console.log('JIBBITZ DE NATURALEZA');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/flower-nature.png?v=1676913090', 'naturaleza');
                  jibbitz_category_name = 'Jibbitz de Naturaleza';
              break;

              case 'JIBBITZ DE PERSONAJES':
                  // console.log('JIBBITZ DE PERSONAJES');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/character.png?v=1676913090', 'personajes');
                  jibbitz_category_name = 'Jibbitz de Personajes';
              break;
              
              case 'JIBBITZ DE SÍMBOLOS':
                  // console.log('JIBBITZ DE SÍMBOLOS');
                  this.renderJibbitzCollectionImg(e, 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/jibbitz-symbols-sayings.png?v=1676907433', 'simbolos');
                  jibbitz_category_name = 'Jibbitz de Símbolos';
              break;                    
          }        
      }); 
    }   
  }

  static renderJibbitzCollectionImg(e, img_url, data){   

    // let jbtz_category = document.querySelector(`[data-filter-name="CATEGORIA"] .data-jibbitz-category="${data}"`);

    // if(!jbtz_category){
      e.insertAdjacentHTML('beforebegin', 
      `<span class="jibbitz-filter-container" data-jibbitz-category="${data}"> 
          <div class="jibbitz-filter" style="display: flex; justify-content: center; align-items: center;">
              <img class="jibbitz-filter__img" src="${img_url}" alt="${e.querySelector('.facet-checkbox__text').textContent.trim().toUpperCase()}">
          </div> 
      </span>
      `);  
    // }
  
  };

  static clearActiveFacetsSizes(){
    let facets_remove = document.querySelectorAll('#FacetsWrapperDesktop .active-facets facet-remove');
    
    facets_remove.forEach((facet, i) => {
      console.log('FACET', facet);
      let facet_inner = facet.querySelector('.active-facets__button .active-facets__button-inner');
      
    
      if(facet_inner !== null){



        let text = facet_inner.childNodes[0].textContent.trim();
        
        if(/.*H.*M.*|.*M.*H.*/.test(text)){

          console.log(text);
          facet_inner.childNodes[0].textContent = text.replace(/-/g, ' ');

          // console.log(replace_text);
       

          // let facet_array = text.split('-');
          // facet_array[1] = `Talla: ${facet_array[1]}`

          // facet_inner.childNodes[0].textContent = facet_array[1];

          // console.log(i);
          // console.log(facet_array);

          // console.log(facet_inner.parentNode.parentNode);
          // console.log(facet_inner.parentNode.parentNode.parentNode);
        }

        // console.log('Facet', facet_inner.childNodes[0].textContent.trim()); 
      }
     
    });
  }
  

  static deleteElementsWithoutStock(){
    const listElements = document.querySelectorAll('.list-menu__item.facets__item');
    console.log('Elementos: ', listElements);
    listElements.forEach(e => {
      e.addEventListener('click', ()=> {
        console.log('click');

        const facetLabel = e.querySelector('.facets__label ');
        if(!facetLabel.classList.contains('active')){
          const facetLabelValue = facetLabel.querySelector('input').value;
          console.log('Valor: ', facetLabelValue);
        }
        
      });
    });
    
  }

  /**/ 

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }

    FacetFiltersForm.clearText();
    FacetFiltersForm.initilizeListSelectors();
    FacetFiltersForm.setSizes(FacetFiltersForm.list_sizes, FacetFiltersForm.summary_size, FacetFiltersForm.sizes_selector_nav, 'desktop');
    FacetFiltersForm.setSizes(FacetFiltersForm.list_sizes_mob, FacetFiltersForm.summary_size_mob, FacetFiltersForm.sizes_selector_nav_mob, 'mobile');
    FacetFiltersForm.removeItemsFromFilterByURL();
    FacetFiltersForm.clearActiveFacetsSizes();
    FacetFiltersForm.deleteElementsWithoutStock();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
    
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

FacetFiltersForm.clearText();
FacetFiltersForm.initilizeListSelectors();
FacetFiltersForm.setSizes(FacetFiltersForm.list_sizes, FacetFiltersForm.summary_size, FacetFiltersForm.sizes_selector_nav, 'desktop');
FacetFiltersForm.setSizes(FacetFiltersForm.list_sizes_mob, FacetFiltersForm.summary_size_mob, FacetFiltersForm.sizes_selector_nav_mob, 'mobile');
FacetFiltersForm.removeItemsFromFilterByURL();
FacetFiltersForm.clearActiveFacetsSizes();
FacetFiltersForm.deleteElementsWithoutStock();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
